import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/images/file.svg'
import _imports_1 from './assets/images/remove.svg'


const _withScopeId = n => (_pushScopeId("data-v-90731268"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  for: "dropzoneFile",
  class: "cursor"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Drag & Drop documents", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "or" }, "OR", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "upload-button" }, "upload File", -1))
const _hoisted_5 = { class: "p-mt-6" }
const _hoisted_6 = {
  key: 0,
  class: "p-d-flex p-flex-column"
}
const _hoisted_7 = { class: "p-d-flex" }
const _hoisted_8 = { style: {"width":"35%"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "p-mr-4"
}, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "p-d-flex p-justify-start p-ai-center"
}
const _hoisted_11 = {
  key: 2,
  class: "uploading-text"
}
const _hoisted_12 = {
  key: 3,
  class: "pi pi-check",
  style: {"color":"red"}
}
const _hoisted_13 = { class: "p-d-flex p-flex-column" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "p-d-flex" }
const _hoisted_16 = { style: {"width":"35%"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "p-mr-4"
}, null, -1))
const _hoisted_18 = {
  key: 0,
  class: "p-d-flex p-justify-start p-ai-center"
}
const _hoisted_19 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_progress_bar = _resolveComponent("progress-bar")!

  return (_openBlock(), _createElementBlock("section", null, [
    ($props.isMyCampaign)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createElementVNode("div", {
            onDragenter: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => ($setup.toggleActive && $setup.toggleActive(...args)), ["prevent"])),
            onDragleave: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.toggleActive && $setup.toggleActive(...args)), ["prevent"])),
            onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
            onDrop: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => ($setup.drop && $setup.drop(...args)), ["prevent"])),
            onChange: _cache[5] || (_cache[5] = _withModifiers(($event: any) => ($setup.onChange()), ["prevent"])),
            class: _normalizeClass([{ 'active-dropzone': $setup.active }, "dropzone"])
          }, [
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("input", {
              type: "file",
              id: "dropzoneFile",
              class: "dropzoneFile",
              ref: "input",
              multiple: "",
              onChange: _cache[0] || (_cache[0] = ($event: any) => {$setup.toggleActive();})
            }, null, 544)
          ], 34)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      ($setup.input?.files.length && !$setup.showRemove)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.input?.files, (file, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "p-mt-2",
                key: `file_${index}`
              }, [
                _createElementVNode("span", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createTextVNode(" " + _toDisplayString(file?.name), 1)
                  ]),
                  ($setup.progressPercents < 100)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                    : _createCommentVNode("", true),
                  ($setup.progressPercents > 0 && $setup.progressPercents < 100)
                    ? (_openBlock(), _createBlock(_component_progress_bar, {
                        key: 1,
                        value: $setup.progressPercents,
                        showValue: false,
                        style: {"width":"265px","height":"6px"},
                        class: "p-mr-3 progres-upload p-ml-3"
                      }, null, 8, ["value"]))
                    : _createCommentVNode("", true),
                  ($setup.progressPercents > 0 && $setup.progressPercents < 100)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Uploading"))
                    : _createCommentVNode("", true),
                  ($setup.progressPercents === 100)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.attachments, (file, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "p-mt-2",
            key: `file_${index}`,
            onClick: file?.url
          }, [
            _createElementVNode("span", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createTextVNode(" " + _toDisplayString(file?.name), 1)
              ]),
              ($setup.progressPercents < 100)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                : _createCommentVNode("", true),
              ($props.isMyCampaign)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "remove-icon",
                    src: _imports_1,
                    onClick: ($event: any) => ($props.campaignID ? $setup.removeFileFromAwsAnsDatabaseMethod($props.campaignID, file._id, index) : $setup.deleteWithUrl(index))
                  }, null, 8, _hoisted_19))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_14))
        }), 128))
      ])
    ])
  ]))
}